"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _elementVariables = _interopRequireDefault(require("@/styles/element-variables.scss"));
var _settings = _interopRequireDefault(require("@/settings"));
var showSettings = _settings.default.showSettings,
  tagsView = _settings.default.tagsView,
  fixedHeader = _settings.default.fixedHeader,
  sidebarLogo = _settings.default.sidebarLogo;
var state = {
  theme: _elementVariables.default.theme,
  showSettings: showSettings,
  tagsView: tagsView,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  noImg: require('@/assets/img/pic.png'),
  noData: require('@/assets/img/zwsj.png'),
  provinceId: localStorage.getItem('provinceId') || '',
  wCourseSource: JSON.parse(localStorage.getItem('wCourseSource')) || [],
  wIndustryType: JSON.parse(localStorage.getItem('wIndustryType')) || [],
  wIndustryCategory: JSON.parse(localStorage.getItem('wIndustryCategory')) || [],
  wJob: JSON.parse(localStorage.getItem('wJob')) || [],
  wProjectLevel: [{
    "id": "1",
    "name": "国家级",
    "sort": 3,
    "value": 1
  }, {
    "id": "2",
    "name": "市级",
    "sort": 2,
    "value": 2
  }],
  wResourceType: JSON.parse(localStorage.getItem('wResourceType')) || [],
  wProfessionalResourceLibraryType: JSON.parse(localStorage.getItem('wProfessionalResourceLibraryType')) || [],
  wCourseLevel: JSON.parse(localStorage.getItem('wCourseLevel')) || [],
  wYearListAll: JSON.parse(localStorage.getItem('wYearListAll')) || [],
  wApplicationType: JSON.parse(localStorage.getItem('wApplicationType')) || [],
  wMediaType: JSON.parse(localStorage.getItem('wMediaType')) || [],
  wMajorListAll: JSON.parse(localStorage.getItem('wMajorListAll')) || [],
  wDigitalCourse: JSON.parse(localStorage.getItem('wDigitalCourse')) || [],
  wVideoClassification: JSON.parse(localStorage.getItem('wVideoClassification')) || [],
  wContestType: JSON.parse(localStorage.getItem('wContestType')) || [],
  // wContestName:JSON.parse(localStorage.getItem('wContestName')) || [],
  wTitle: '北京职业教育智慧平台',
  wShoolInfo: JSON.parse(localStorage.getItem('wShoolInfo')) || {},
  wCode: localStorage.getItem('wCode') || ''
};
var mutations = {
  CHANGE_SETTING: function CHANGE_SETTING(state, _ref) {
    var key = _ref.key,
      value = _ref.value;
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  },
  getwCourseSource: function getwCourseSource(state, e) {
    localStorage.setItem('wCourseSource', JSON.stringify(e));
    state.wCourseSource = e;
  },
  getwIndustryType: function getwIndustryType(state, e) {
    localStorage.setItem('wIndustryType', JSON.stringify(e));
    state.wIndustryType = e;
  },
  getwIndustryCategory: function getwIndustryCategory(state, e) {
    localStorage.setItem('wIndustryCategory', JSON.stringify(e));
    state.wIndustryCategory = e;
  },
  getwJob: function getwJob(state, e) {
    localStorage.setItem('wJob', JSON.stringify(e));
    state.wJob = e;
  },
  getwProjectLevel: function getwProjectLevel(state, e) {
    localStorage.setItem('wProjectLevel', JSON.stringify(e));
    state.wProjectLevel = e;
  },
  getwResourceType: function getwResourceType(state, e) {
    localStorage.setItem('wResourceType', JSON.stringify(e));
    state.wResourceType = e;
  },
  getwProfessionalResourceLibraryType: function getwProfessionalResourceLibraryType(state, e) {
    localStorage.setItem('wProfessionalResourceLibraryType', JSON.stringify(e));
    state.wProfessionalResourceLibraryType = e;
  },
  getwCourseLevel: function getwCourseLevel(state, e) {
    localStorage.setItem('wCourseLevel', JSON.stringify(e));
    state.wCourseLevel = e;
  },
  getwYearListAll: function getwYearListAll(state, e) {
    localStorage.setItem('wYearListAll', JSON.stringify(e));
    state.wYearListAll = e;
  },
  getwApplicationType: function getwApplicationType(state, e) {
    localStorage.setItem('wApplicationType', JSON.stringify(e));
    state.wApplicationType = e;
  },
  getwMediaType: function getwMediaType(state, e) {
    localStorage.setItem('wMediaType', JSON.stringify(e));
    state.wMediaType = e;
  },
  getwMajorListAll: function getwMajorListAll(state, e) {
    localStorage.setItem('wMajorListAll', JSON.stringify(e));
    state.wMajorListAll = e;
  },
  getwDigitalCourse: function getwDigitalCourse(state, e) {
    localStorage.setItem('wDigitalCourse', JSON.stringify(e));
    state.wDigitalCourse = e;
  },
  getwVideoClassification: function getwVideoClassification(state, e) {
    localStorage.setItem('wVideoClassification', JSON.stringify(e));
    state.wVideoClassification = e;
  },
  getwContestType: function getwContestType(state, e) {
    localStorage.setItem('wContestType', JSON.stringify(e));
    state.wContestType = e;
  },
  getwContestName: function getwContestName(state, e) {
    localStorage.setItem('wContestName', JSON.stringify(e));
    state.wContestName = e;
  },
  getwTitle: function getwTitle(state, e) {
    localStorage.setItem('wTitle', e);
    state.wTitle = e;
  },
  getProvinceId: function getProvinceId(state, e) {
    localStorage.setItem('provinceId', e);
    state.provinceId = e;
  },
  getwShoolInfo: function getwShoolInfo(state, e) {
    localStorage.setItem('wShoolInfo', JSON.stringify(e));
    state.wShoolInfo = e;
  },
  getwCode: function getwCode(state, e) {
    localStorage.setItem('wCode', e);
    state.wCode = e;
  }
};
var actions = {
  changeSetting: function changeSetting(_ref2, data) {
    var commit = _ref2.commit;
    commit('CHANGE_SETTING', data);
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};